import React, { useState } from "react";
import { Card } from "@my-scoot/component-library-legacy";
import styles from "./SalesPagesListItemCard.module.css";
import useDesktopMediaQuery from "hooks/useDesktopMediaQuery";
import classnames from "classnames";
import ExlyPopover from "common/Components/ExlyPopover";
import {
  sales_page_editing_stages,
  sales_page_editing_stages_keys,
} from "ui/pages/SalesPages/pages/SalesPagesHome/constants";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import ExlyImage from "common/Components/ExlyImage";
import {
  app_pathnames,
  app_route_ids,
  app_route_keys,
} from "constants/urlPaths";
import { useHistory } from "react-router-dom";
import { LazyLoadedShareSalePageModal } from "ui/pages/SalesPages/pages/SalesPagesHome/components/ShareSalePageModal/LazyLoadedShareSalePageModal";
import { sales_pages_apis } from "ui/pages/SalesPages/API";
import { dataProvider } from "data";
import {
  notification_color_keys,
  useNotifications,
  useToggleState,
} from "utils/hooks";
import { MobileDataItem } from "ui/pages/communications/CustomEmail/components/EmailListItem/components/MobileRow/MobileDataItem";
import { useRefresh } from "react-admin";
import { LazyLoadedDeleteSalePageModal } from "ui/pages/SalesPages/pages/SalesPagesHome/components/DeleteSalePageModal/LazyLoadedDeleteSalePageModal";
import { getSalePageUrl } from "features/SalesPages/utils/getSalePageUrl";
import { default_template_preview_image } from "ui/pages/SalesPages/constants";
import { LazyLoadedEditSalePageTitleModal } from "ui/pages/SalesPages/pages/SalesPagesHome/components/EditSalePageTitleModal/LazyLoadedEditSalePageTitleModal";
import { offering_status_labels } from "features/Listings/Listings.constants";
import ExlyTooltip from "ui/modules/Tooltip";
import {
  offering_status_tooltip_texts,
  STATUS_BADGE_CONFIGS,
} from "features/SalesPages/modules/SalesPagesListItemCard/constants/SalesPagesListItemCard.constants";
import LinkIcon from "@material-ui/icons/Link";
import EditIcon from "@material-ui/icons/Edit";
import { ReactComponent as TemplateSelectingStageIcon } from "ui/pages/SalesPages/assets/draftStages/TemplateSelectingStageIcon.svg";
import { ReactComponent as DetailsEditingStageIcon } from "ui/pages/SalesPages/assets/draftStages/DetailsEditingStageIcon.svg";
import { ReactComponent as PublishedStageIcon } from "ui/pages/SalesPages/assets/draftStages/PublishedStageIcon.svg";
import {
  GJS_PAGE_BUILDER_ROUTE_GENERATORS,
  GJS_PAGE_BUILDER_ROUTE_KEYS,
} from "features/SalesPages/modules/GJSSalePageBuilder/constants/GJSSalePageBuilder.constants";
import { checkPgBuilderSourceIsGJS } from "features/SalesPages/utils/checkPgBuilderSourceIsGJS";
import {
  PAGE_BUILDER_SOURCES,
  sales_page_detail_keys,
  sales_page_metadata_keys,
} from "features/SalesPages/constants/SalesPages.constants";
import { logError } from "utils/error";
import LazyLoadedChangeListingModal from "../ChangeListingModal/LazyLoadedChangeListingModal";
import { useFetchListingDetails } from "features/Listings/utils/useFetchListingDetails";
import { apiMethods } from "data/api.constants";
import { MenuButtonComponent } from "./modules/MenuButtonComponent";
import { MenuPopoverComponent } from "./modules/MenuPopoverComponent/MenuPopoverComponent";
import DesktopOnlyFeatureModal from "features/DesktopOnlyFeatureModal/DesktopOnlyFeatureModal";
import debounce from "lodash/debounce";
import useFeatureOnboardingChecker from "common/Components/FeatureOnboarding/useFeatureOnboardingChecker";
import { onboardingFeatureKeys } from "common/Components/FeatureOnboarding/FeatureOnboarding.constants";
import moment from "moment";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import {
  AI_PAGE_BUILDER_ROUTE_GENERATORS,
  AI_PAGE_BUILDER_ROUTE_KEYS,
} from "../AiPageBuilder/constants/AiSalePageBuilder.constants";
import {
  is_empty,
  formatRevenue,
  SHOW_TOTAL_VISITORS,
} from "features/Common/utils/common.utils";
import { ISSUE_IN_AI_EDIT_OPEN } from "constants/displayStrings";
import { checkIsObjectEmpty } from "features/Common/modules/DataTypes/utils/object";

// TODO: breakdown this file
export const SalesPagesListItemCard = ({ data, templatesList }) => {
  const isDesktop = useDesktopMediaQuery();
  const history = useHistory();
  const refresh = useRefresh();
  const { notify } = useNotifications();
  const { fetchListingDetails } = useFetchListingDetails();
  const { isOnboarded: hasSharedSalesPageLink, handleFeatureOnboardChange } =
    useFeatureOnboardingChecker({
      featureKey: onboardingFeatureKeys.HAS_SHARED_SALES_PAGE_LINK,
    });

  const template =
    (data.template_uid &&
      templatesList.find((i) => i.uuid === data.template_uid)) ||
    {};

  const previewImage =
    (isDesktop
      ? template.desktop_preview_image
      : template.mobile_preview_image) || default_template_preview_image;

  const salePageStage = data.sales_page_stage;
  const isSalesPageLive =
    data[sales_page_detail_keys.sales_page_stage] ===
    sales_page_editing_stages_keys.published;

  const offeringAvailabilityStatus = data.listing_status;

  const [showShareSalePageModal, setShowShareSalePageModal] = useState();
  const onShareButtonClick = () => {
    setShowShareSalePageModal(true);
  };

  const [showDeleteSalePageModal, setShowDeleteSalePageModal] = useState();
  const [showChangeOfferingModal, setShowChangeOfferingModal] = useState();
  const [salePageListingDetails, setSalePageListingDetails] = useState({});
  const onDeletePageClick = () => {
    setShowDeleteSalePageModal(true);
  };
  const [showEditSalePageTitleModal, setShowEditSalePageTitleModal] =
    useState();
  const onEditSalePageTitleClick = () => {
    setShowEditSalePageTitleModal(true);
  };

  const onChangeOfferingClick = async (e) => {
    if (e?.stopPropagation) e.stopPropagation();
    if (data?.listing_uuid) {
      const listingDetails = await fetchListingDetails({
        listingUuid: data.listing_uuid,
      });
      setSalePageListingDetails(listingDetails);
    } else {
      setSalePageListingDetails({});
    }
    setShowChangeOfferingModal(true);
  };

  const onChangeOfferingClose = () => {
    setShowChangeOfferingModal(false);
  };

  const onGoToTrafficAnalysisClick = () => {
    history.push("/" + app_route_ids[app_route_keys.traffic_analysis]);
  };

  const [duplicating, setDuplicating] = useState(false);

  const onDuplicatePageClick = debounce(() => {
    if (duplicating) return;
    setDuplicating(true);
    dataProvider
      .custom_request(sales_pages_apis.duplicate_sale_page, apiMethods.POST, {
        sales_page_uuid: data.uuid,
      })
      .then(() => {
        notify(
          "Duplicate page saved as draft",
          notification_color_keys.success
        );
        refresh();
      })
      .catch((err) => {
        logError({
          error: err,
          occuredAt:
            "src/ui/pages/SalesPages/pages/SalesPagesHome/components/SalesPagesListItemCard/SalesPagesListItemCard.jsx",
          when: "calling onDuplicatePageClick",
        });
        notify(
          "An error occured. Please try again after some time.",
          notification_color_keys.error
        );
      })
      .finally(() => setDuplicating(false));
  }, 300);

  const onCopySalePageLinkButtonClick = (e) => {
    if (e?.stopPropagation) e.stopPropagation();
    if (navigator?.clipboard) {
      const salePageUrl = getSalePageUrl({ salePageDetail: data });
      navigator.clipboard.writeText(salePageUrl);
      notify("Link Copied!", notification_color_keys.info);
      updateClickedOnShare();
    }
  };

  const [
    desktopOnlyFeatureModalIsOpen,
    openDesktopOnlyFeatureModal,
    closeDesktopOnlyFeatureModal,
  ] = useToggleState(false);

  const pageBuilderSource = data[sales_page_detail_keys.page_builder_source];

  const isAiPage = pageBuilderSource === PAGE_BUILDER_SOURCES.ai_builder;

  const isPgBuilderSourceGJS = checkPgBuilderSourceIsGJS(
    data?.[sales_page_detail_keys.metadata]?.[
      sales_page_metadata_keys.page_builder_source
    ] || data[sales_page_detail_keys.page_builder_source]
  );

  const onEditSalesPageClick = () => {
    if ((isPgBuilderSourceGJS || isAiPage) && !isDesktop) {
      openDesktopOnlyFeatureModal();
      return;
    }

    const aiConversationUid =
      data?.[sales_page_detail_keys.metadata]?.[
        sales_page_metadata_keys.ai_conversation_uid
      ];
    if (isAiPage && is_empty(aiConversationUid)) {
      notify(ISSUE_IN_AI_EDIT_OPEN, notification_color_keys.error);
      return;
    }

    if (salePageStage === sales_page_editing_stages_keys.selecting_template) {
      if (isAiPage) {
        // Navigate to AI Template selection screen
        history.push(
          AI_PAGE_BUILDER_ROUTE_GENERATORS[
            AI_PAGE_BUILDER_ROUTE_KEYS.select_template
          ]({
            ai_conversation_uid: aiConversationUid,
          })
        );
      } else {
        history.push(
          app_pathnames[app_route_keys.sales_pages_update_template]({
            salePageUuid: data[sales_page_detail_keys.uuid],
          })
        );
      }
    } else {
      if (isAiPage) {
        // Navigate to AI Template editing screen
        history.push(
          AI_PAGE_BUILDER_ROUTE_GENERATORS[AI_PAGE_BUILDER_ROUTE_KEYS.editor]({
            conversationUid: aiConversationUid,
          })
        );
      } else if (isPgBuilderSourceGJS) {
        // Navigate to GrapeJS Builder editing screen
        history.push(
          GJS_PAGE_BUILDER_ROUTE_GENERATORS[GJS_PAGE_BUILDER_ROUTE_KEYS.update](
            {
              salePageUuid: data[sales_page_detail_keys.uuid],
              templateUuid: data[sales_page_detail_keys.template_uid],
            }
          )
        );
      } else {
        // Navigate to Classic Builder editing screen
        history.push(
          app_pathnames[app_route_keys.sales_pages_update_details]({
            salePageUuid: data.uuid,
            templateUuid: data.template_uid,
          })
        );
      }
    }
  };

  const onPreviewSalePageBtnClick = (e) => {
    if (e?.stopPropagation) e.stopPropagation();

    const aiConversationUid =
      data?.[sales_page_detail_keys.metadata]?.[
        sales_page_metadata_keys.ai_conversation_uid
      ];
    if (isAiPage && is_empty(aiConversationUid)) {
      notify(ISSUE_IN_AI_EDIT_OPEN, notification_color_keys.error);
      return;
    }

    if (isAiPage) {
      history.push(
        AI_PAGE_BUILDER_ROUTE_GENERATORS[AI_PAGE_BUILDER_ROUTE_KEYS.editor]({
          conversationUid: aiConversationUid,
        })
      );
    } else {
      history.push(
        "/" +
          app_pathnames[app_route_keys.sales_pages_preview]({
            salePageUuid: data.uuid,
          })
      );
    }
  };

  const previewSalePageButtonJSX = isDesktop ? (
    <div
      className="tw-w-[40px] tw-h-[40px] tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-border-[#E7E6E4] tw-rounded-lg tw-cursor-pointer hover:tw-bg-gray-50"
      onClick={(e) => {
        if (e?.stopPropagation) e.stopPropagation();
        onPreviewSalePageBtnClick(e);
      }}
      title="Preview page"
    >
      <VisibilityOutlinedIcon className="tw-text-[#272522] tw-text-[18px]" />
    </div>
  ) : (
    <VisibilityOutlinedIcon
      className={styles.actionBtn}
      onClick={onPreviewSalePageBtnClick}
    />
  );

  const CustomMenuButtonComponent = ({ openPopover }) => (
    <div
      className="tw-w-[40px] tw-h-[40px] tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-border-[#E7E6E4] tw-rounded-lg tw-cursor-pointer hover:tw-bg-gray-50"
      onClick={(e) => {
        if (e?.stopPropagation) e.stopPropagation();
        openPopover(e);
      }}
    >
      <MoreVertIcon className="tw-text-[#272522] tw-text-[18px]" />
    </div>
  );

  const moreOptionsJSX = (
    <div>
      <ExlyPopover
        AnchorComponent={
          isDesktop ? CustomMenuButtonComponent : MenuButtonComponent
        }
        PopoverComponent={(popoverComponentProps) => (
          <MenuPopoverComponent
            {...popoverComponentProps}
            onEditSalesPageClick={onEditSalesPageClick}
            onEditSalePageTitleClick={onEditSalePageTitleClick}
            isAiPage={isAiPage}
            pageBuilderSource={pageBuilderSource}
            onGoToTrafficAnalysisClick={onGoToTrafficAnalysisClick}
            onChangeOfferingClick={onChangeOfferingClick}
            onDuplicatePageClick={onDuplicatePageClick}
            onCopySalePageLinkButtonClick={onCopySalePageLinkButtonClick}
            onShareButtonClick={onShareButtonClick}
            onPreviewSalePageBtnClick={onPreviewSalePageBtnClick}
            onDeletePageClick={onDeletePageClick}
          />
        )}
        popoverProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "right",
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          classes: {
            paper: styles.menuPopoverContainer,
          },
        }}
        onClose={(e) => {
          // to stop triggering card click
          if (e?.stopPropagation) e.stopPropagation();
        }}
        forceDesktopDesign={false}
      />
    </div>
  );

  const listingTitleJSX = (
    <div
      className={classnames(styles.offeringName, "ellipsis")}
      title={data.listing_title}
    >
      {data.listing_title}
    </div>
  );

  const offeringAvailabilityStatusJSX = (
    <div className={styles.offeringAvailabilityStatusCtn}>
      <div
        className={classnames(
          styles.offeringAvailabilityStatus,
          styles[`offeringAvailabilityStatus_${offeringAvailabilityStatus}`]
        )}
      >
        {offering_status_labels[offeringAvailabilityStatus]}
      </div>
      <ExlyTooltip
        text={offering_status_tooltip_texts[offeringAvailabilityStatus]}
      />
    </div>
  );

  const horizontalBarJSX = (
    <div
      className={classnames(
        isDesktop ? "px-3" : "px-2",
        "mx-1 border-top border-bottom"
      )}
    />
  );

  const iconDimensionInPx = isDesktop ? 31 : 24;

  let badgeConfig = STATUS_BADGE_CONFIGS.draft;
  let badgeLabel =
    sales_page_editing_stages[salePageStage]?.stageText || "Draft";

  if (isSalesPageLive) {
    if (offeringAvailabilityStatus === 1) {
      badgeConfig = STATUS_BADGE_CONFIGS.active;
      badgeLabel = STATUS_BADGE_CONFIGS.active.label;
    } else if (offeringAvailabilityStatus === 2) {
      badgeConfig = STATUS_BADGE_CONFIGS.paused;
      badgeLabel = STATUS_BADGE_CONFIGS.paused.label;
    } else {
      badgeConfig = STATUS_BADGE_CONFIGS.inactive;
      badgeLabel = STATUS_BADGE_CONFIGS.inactive.label;
    }
  }

  const salePageStatusJSX = isDesktop ? (
    isSalesPageLive ? (
      <div
        className={classnames(
          "tw-flex tw-items-center tw-gap-1.5 tw-px-2.5 tw-py-1 tw-rounded-full tw-text-[12px] tw-font-semibold",
          badgeConfig.bg,
          badgeConfig.text
        )}
      >
        <span>{badgeLabel}</span>
        <span
          className={classnames(
            "tw-w-1.5 tw-h-1.5 tw-rounded-full",
            badgeConfig.dot
          )}
        />
      </div>
    ) : (
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-1.5">
        <div className="tw-flex tw-items-center">
          <TemplateSelectingStageIcon
            width={iconDimensionInPx}
            height={iconDimensionInPx}
            className={classnames(
              styles.templateSelectingStageIcon,
              salePageStage ===
                sales_page_editing_stages_keys.selecting_template
                ? styles.on
                : styles.after
            )}
          />
          {horizontalBarJSX}
          <DetailsEditingStageIcon
            width={iconDimensionInPx}
            height={iconDimensionInPx}
            className={classnames(
              styles.detailsEditingStageIcon,
              salePageStage ===
                sales_page_editing_stages_keys.selecting_template
                ? styles.before
                : "",
              salePageStage === sales_page_editing_stages_keys.editing_details
                ? styles.on
                : ""
            )}
          />
          {horizontalBarJSX}
          <PublishedStageIcon
            width={iconDimensionInPx}
            height={iconDimensionInPx}
            className={classnames(styles.publishedStageIcon)}
          />
        </div>
        <div
          className={classnames(
            styles.stageText,
            "tw-text-[16px] tw-text-[#493AB1] tw-font-semibold tw-mt-1"
          )}
        >
          On step{" "}
          {salePageStage === sales_page_editing_stages_keys.selecting_template
            ? "1"
            : "2"}
          : {sales_page_editing_stages[salePageStage]?.stageText}
        </div>
      </div>
    )
  ) : isSalesPageLive ? (
    offeringAvailabilityStatusJSX
  ) : (
    <div
      className={classnames(
        "d-flex align-items-center justify-content-between",
        isDesktop && "flex-column"
      )}
    >
      <div className="d-flex align-items-center">
        <TemplateSelectingStageIcon
          width={iconDimensionInPx}
          height={iconDimensionInPx}
          className={classnames(
            styles.templateSelectingStageIcon,
            salePageStage === sales_page_editing_stages_keys.selecting_template
              ? styles.on
              : styles.after
          )}
        />
        {horizontalBarJSX}
        <DetailsEditingStageIcon
          width={iconDimensionInPx}
          height={iconDimensionInPx}
          className={classnames(
            styles.detailsEditingStageIcon,
            salePageStage === sales_page_editing_stages_keys.selecting_template
              ? styles.before
              : "",
            salePageStage === sales_page_editing_stages_keys.editing_details
              ? styles.on
              : ""
          )}
        />
        {horizontalBarJSX}
        <PublishedStageIcon
          width={iconDimensionInPx}
          height={iconDimensionInPx}
          className={classnames(styles.publishedStageIcon)}
        />
      </div>
      {isDesktop ? (
        <div className={styles.stageText}>
          {sales_page_editing_stages[salePageStage]?.stageText}
        </div>
      ) : null}
    </div>
  );

  const copySalePageLinkButtonJSX = isSalesPageLive ? (
    isDesktop ? (
      <div
        className="tw-w-[40px] tw-h-[40px] tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-border-[#E7E6E4] tw-rounded-lg tw-cursor-pointer hover:tw-bg-gray-50"
        onClick={(e) => {
          if (e?.stopPropagation) e.stopPropagation();
          onCopySalePageLinkButtonClick(e);
        }}
        title="Copy link"
      >
        <LinkIcon className="tw-text-[#272522] tw-text-[18px]" />
      </div>
    ) : (
      <LinkIcon
        className={classnames(styles.copyButtonIcon, styles.actionBtn)}
        onClick={onCopySalePageLinkButtonClick}
      />
    )
  ) : null;

  const editSalePageButtonJSX = isDesktop ? (
    <div
      className="tw-w-[40px] tw-h-[40px] tw-flex tw-items-center tw-justify-center tw-border tw-border-solid tw-border-[#E7E6E4] tw-rounded-lg tw-cursor-pointer hover:tw-bg-gray-50"
      onClick={(e) => {
        if (e?.stopPropagation) e.stopPropagation();
        onEditSalesPageClick();
      }}
      title="Edit page"
    >
      <EditIcon className="tw-text-[#272522] tw-text-[18px]" />
    </div>
  ) : (
    <EditIcon className={styles.actionBtn} />
  );

  const updateClickedOnShare = () => {
    if (!hasSharedSalesPageLink) {
      handleFeatureOnboardChange(true);
    }
  };

  const cardBottomStatsJSX = (
    <>
      <div className="tw-h-[1px] tw-mt-5 tw-w-full tw-bg-[#E7E6E4] tw-my-[10px]" />
      <div className="tw-flex tw-items-center tw-justify-between tw-w-full tw-pt-2">
        {SHOW_TOTAL_VISITORS && (
          <>
            <MobileDataItem
              title="Total Visitors"
              data={data?.total_visitors ?? 0}
              icon="leadIcon.png"
              color="#316e84"
              className="!tw-bg-white"
            />
            <div className="tw-w-[1px] tw-bg-[#E7E6E4] tw-h-12 tw-mx-4 tw-flex-shrink-0" />
          </>
        )}
        <MobileDataItem
          title="Total Leads"
          data={data?.total_leads ?? 0}
          icon="group.png"
          color="#0052CC"
          className="!tw-bg-white"
        />
        <div className="tw-w-[1px] tw-bg-[#E7E6E4] tw-h-12 tw-mx-4 tw-flex-shrink-0" />
        <MobileDataItem
          title="Total Bookings"
          data={data?.total_bookings ?? 0}
          icon="booking.png"
          color="#493AB1"
          className="!tw-bg-white"
        />
        <div className="tw-w-[1px] tw-bg-[#E7E6E4] tw-h-12 tw-mx-4 tw-flex-shrink-0" />
        <MobileDataItem
          title="Total Revenue"
          data={formatRevenue(data?.total_revenue)}
          icon="revenue.png"
          color="#00B77A"
          className="!tw-bg-white"
        />
      </div>
    </>
  );

  const mobileStats = [
    ...(SHOW_TOTAL_VISITORS
      ? [
          {
            title: "Total Visitors",
            data: data?.total_visitors ?? 0,
            color: "#316e84",
            icon: "leadIcon.png",
          },
        ]
      : []),
    {
      title: "Total Leads",
      data: data?.total_leads ?? 0,
      color: "#0052CC",
      icon: "group.png",
    },
    {
      title: "Total Bookings",
      data: data?.total_bookings ?? 0,
      color: "#493AB1",
      icon: "booking.png",
    },
    {
      title: "Total Revenue",
      data: formatRevenue(data?.total_revenue),
      color: "#00B77A",
      icon: "revenue.png",
    },
  ];

  return (
    <>
      {isDesktop ? (
        <div
          className="tw-flex tw-flex-col tw-p-6 tw-bg-white tw-border tw-border-solid tw-border-[#E7E6E4] tw-rounded-2xl tw-cursor-pointer hover:tw-shadow-sm tw-transition-all tw-duration-200"
          onClick={onEditSalesPageClick}
        >
          {/* Top row */}
          <div className="tw-flex tw-justify-between tw-items-center">
            {/* Left side: thumbnail + info */}
            <div className="tw-flex tw-items-center tw-flex-1 tw-min-w-0">
              <ExlyImage
                src={previewImage}
                height={80}
                width={150}
                className="tw-rounded-xl tw-object-cover tw-border tw-border-solid tw-border-gray-100"
              />
              <div className="tw-flex tw-flex-col tw-ml-4 tw-min-w-0">
                <div>
                  <div
                    className="tw-text-[16px] tw-font-bold tw-text-[#272522] tw-truncate"
                    title={data.title}
                  >
                    {data.title}
                  </div>
                  <div
                    className="tw-text-[14px] tw-text-[#272522] tw-opacity-60 tw-truncate"
                    title={data.listing_title}
                  >
                    {data.listing_title}
                  </div>
                </div>
                <div className="tw-flex tw-items-center tw-gap-3 tw-mt-2.5">
                  {/* Status badge */}
                  {isSalesPageLive && salePageStatusJSX}
                  {/* Vertical line and Date */}
                  {isSalesPageLive && (
                    <span className="tw-text-[#E7E6E4]">|</span>
                  )}
                  <span className="tw-text-[12px] tw-text-[#272522] tw-opacity-60">
                    Created on{" "}
                    {data.created_at
                      ? moment(data.created_at).format("DD MMM YYYY")
                      : ""}
                  </span>
                </div>
              </div>
            </div>

            {/* Middle: If Draft, show steps progress bar in the center */}
            {!isSalesPageLive && (
              <div
                className="tw-flex-1 tw-flex tw-justify-center tw-px-4"
                onClick={(e) => e.stopPropagation()}
              >
                {salePageStatusJSX}
              </div>
            )}

            {/* Right side: immediate actions + more actions popover */}
            <div
              className="tw-flex tw-items-center tw-gap-3"
              onClick={(e) => e.stopPropagation()}
            >
              {copySalePageLinkButtonJSX}
              {editSalePageButtonJSX}
              {previewSalePageButtonJSX}
              {moreOptionsJSX}
            </div>
          </div>

          {/* Bottom stats row if live */}
          {isSalesPageLive && cardBottomStatsJSX}
        </div>
      ) : (
        <Card
          shadow="none"
          className={styles.container}
          onClick={onEditSalesPageClick}
        >
          <div className="d-flex align-items-center justify-content-between p-2 border-bottom">
            <div className={classnames(styles.title, "ellipsis")}>
              {data.title}
            </div>
            {moreOptionsJSX}
          </div>
          <div className="m-1 p-2 d-flex">
            <div
              className={classnames(
                styles.previewImageCtn,
                "rounded border mr-3"
              )}
            >
              <ExlyImage src={previewImage} className={styles.previewImage} />
            </div>
            <div
              className={classnames(
                styles.rightContainer,
                "d-flex flex-column w-100 ellipsis"
              )}
            >
              <div className="flex-grow-1 ellipsis">
                <div
                  className={classnames(
                    styles.createdForStaticText,
                    "text-muted"
                  )}
                >
                  Created for
                </div>
                {listingTitleJSX}
              </div>
              {salePageStatusJSX}
            </div>
          </div>
          {isSalesPageLive && !checkIsObjectEmpty(mobileStats) && (
            <>
              <hr className="tw-border-none tw-h-[1px] tw-bg-[#E7E6E4] tw-m-0" />
              <div className="tw-grid tw-gap-2 tw-p-3 tw-grid-cols-2">
                {mobileStats.map((item) => (
                  <MobileDataItem
                    key={item.title}
                    title={item.title}
                    data={item.data}
                    icon={item.icon}
                    color={item.color}
                  />
                ))}
              </div>
            </>
          )}
        </Card>
      )}
      <LazyLoadedShareSalePageModal
        open={showShareSalePageModal}
        salePageData={data}
        onClose={() => {
          setShowShareSalePageModal(false);
        }}
      />
      <LazyLoadedDeleteSalePageModal
        open={showDeleteSalePageModal}
        salePageData={data}
        onClose={() => {
          setShowDeleteSalePageModal(false);
        }}
      />
      <LazyLoadedEditSalePageTitleModal
        open={showEditSalePageTitleModal}
        salePageData={data}
        onClose={() => {
          setShowEditSalePageTitleModal(false);
        }}
      />
      <DesktopOnlyFeatureModal
        isOpen={desktopOnlyFeatureModalIsOpen}
        onClose={closeDesktopOnlyFeatureModal}
        description="Kindly use your desktop to edit this page as it was created using the Page Builder"
      />
      <LazyLoadedChangeListingModal
        open={showChangeOfferingModal}
        salePageData={data}
        onClose={onChangeOfferingClose}
        salePageListingDetails={salePageListingDetails}
      />
    </>
  );
};
